import { CLAIM_API_URL, fmhAPI } from 'api/APIBase';

export async function postCloseWithExceptionFile({ payerId, file }) {
    const url = `${CLAIM_API_URL}/${payerId}/close_with_exception`;
    return fmhAPI.base.url(url).formData({ file }).post().json();
}
